<div class="retailer-order-shell">
    <div class="container fw-b">
        <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
    </div>

    <!-- Hero Cards -->
    <section class="container order-hero">
        <div class="hero-container-card">
            <div class="hero-cards-wrapper">
                <div class="hero-stat-card pending-card">
                    <div class="card-accent-strip pending-accent"></div>
                    <div class="card-content">
                        <div class="card-icon-wrapper pending-icon">
                            <i class="fa fa-clock-o" aria-hidden="true"></i>
                        </div>
                        <p class="stat-amount">{{ pendingCount || 0 }}</p>
                        <label class="stat-label">PENDING ORDERS</label>
                    </div>
                </div>
                <div class="hero-stat-card delivered-card">
                    <div class="card-accent-strip delivered-accent"></div>
                    <div class="card-content">
                        <div class="card-icon-wrapper delivered-icon">
                            <i class="fa fa-check-circle" aria-hidden="true"></i>
                        </div>
                        <p class="stat-amount">{{ deliveredCount || 0 }}</p>
                        <label class="stat-label">DELIVERED ORDERS</label>
                    </div>
                </div>
                <div class="hero-stat-card total-card">
                    <div class="card-accent-strip total-accent"></div>
                    <div class="card-content">
                        <div class="card-icon-wrapper total-icon">
                            <i class="fa fa-list-alt" aria-hidden="true"></i>
                        </div>
                        <p class="stat-amount">{{ (pendingCount || 0) + (deliveredCount || 0) }}</p>
                        <label class="stat-label">TOTAL ORDERS</label>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Tabs -->
    <section class="container order-tabs">
        <div class="row g-3">
            <div class="col-sm-6">
                <button class="tabBtn" [ngClass]="{active : btn == 'Pending'}" (click)="selectBtn('Pending')">
                    <span>Pending</span>
                </button>
            </div>
            <div class="col-sm-6">
                <button class="tabBtn" [ngClass]="{active : btn == 'Complete'}" (click)="selectBtn('Complete')">
                    <span>Delivered</span>
                </button>
            </div>
        </div>
    </section>

    <section class="container table-wrapper">
        <!-- Pending table -->
        <article class="order-table-card" *ngIf="btn == 'Pending'">
            <div class="table-header">
                <div>
                    <p class="section-eyebrow">Pending Orders</p>
                    <h2>Orders awaiting action</h2>
                </div>
                <span class="badge-counter">{{ count || 0 }} orders</span>
            </div>

            <div class="table-responsive">
                <table class="table modern-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Image</th>
                            <th>Customer Name</th>
                            <th>Order Id</th>
                            <th>Order Date & Time</th>
                            <th>Total Amount</th>
                            <th>Payment Status</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of orderList | paginate:{itemsPerPage:pageSize, currentPage: currentPage,totalItems: count}; let i=index;">
                            <td data-label="S.No">{{10 * (currentPage - 1) + i+1}}</td>
                            <td data-label="Image">
                                <div class="thumb-frame">
                                    <img class="imagtag" [src]="item?.myOrders[0]?.productId?.thumbnail" alt="">
                                </div>
                            </td>
                            <td data-label="Customer Name">{{item?.userId?.firstName}} {{item?.userId?.lastName}}</td>
                            <td data-label="Order Id">{{item?.orderId}}</td>
                            <td data-label="Order Date & Time">{{item?.createdAt | date: 'yyyy-MM-dd h:mm:ss a' || '--'}}</td>
                            <td data-label="Total Amount" class="red-color">{{ getTotalOrderPrice(item.myOrders) | currency:'ZAR':'R' }}</td>
                            <td data-label="Payment Status">
                                <span
                                  class="status-chip"
                                  [ngClass]="(item?.paymentStatus || '').toLowerCase()"
                                >
                                  {{ item?.paymentStatus || '--' }}
                                </span>
                            </td>
                            <td data-label="Action" class="text-center">
                                <button class="ghost-link"
                                    [queryParams]="{_id : item?._id, status: item?.orderStatus}"
                                    [routerLink]="['/retailer-order-history-view']">
                                    View
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <app-table-loader [isTable]="'TABLE'" [isLoading]="isLoading" [notFoundData]="notFoundData"
                [colspan]="10" [isWidth]="'80px'"></app-table-loader>
            <div class="table-footer" *ngIf="count > 10">
                <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
            </div>
        </article>

        <!-- Complete table -->
        <article class="order-table-card" *ngIf="btn == 'Complete'">
            <div class="table-header">
                <div>
                    <p class="section-eyebrow">Delivered Orders</p>
                    <h2>Completed & fulfilled</h2>
                </div>
                <span class="badge-counter">{{ count || 0 }} orders</span>
            </div>

            <div class="table-responsive">
                <table class="table modern-table">
                    <thead>
                        <tr>
                            <th>S.No</th>
                            <th>Image</th>
                            <th>Customer Name</th>
                            <th>Order Id</th>
                            <th>Order Date & Time</th>
                            <th>Total Amount</th>
                            <th>Payment Status</th>
                            <th class="text-center">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of orderList | paginate:{itemsPerPage:pageSize, currentPage: currentPage,totalItems: count}; let i=index;">
                            <td data-label="S.No">{{10 * (currentPage - 1) + i+1}}</td>
                            <td data-label="Image">
                                <div class="thumb-frame">
                                    <img class="imagtag" [src]="item?.myOrders[0]?.productId?.thumbnail" alt="">
                                </div>
                            </td>
                            <td data-label="Customer Name">{{item?.userId?.firstName}} {{item?.userId?.lastName}}</td>
                            <td data-label="Order Id">{{item?.orderId}}</td>
                            <td data-label="Order Date & Time">{{item?.createdAt | date: 'yyyy-MM-dd h:mm:ss a' || '--'}}</td>
                            <td data-label="Total Amount" class="red-color">{{ getTotalOrderPrice(item.myOrders) | currency:'ZAR':'R' }}</td>
                            <td data-label="Payment Status">
                                <span
                                  class="status-chip"
                                  [ngClass]="(getPaymentStatus(item) || '').toLowerCase()"
                                >
                                  {{ getPaymentStatus(item) || '--' }}
                                </span>
                            </td>
                            <td data-label="Action" class="text-center">
                                <button class="ghost-link"
                                    [queryParams]="{_id : item?._id, status: item?.orderStatus}"
                                    [routerLink]="['/retailer-order-history-view']">
                                    View
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <app-table-loader [isTable]="'TABLE'" [isLoading]="isLoading" [notFoundData]="notFoundData"
                [colspan]="10" [isWidth]="'80px'"></app-table-loader>
            <div class="table-footer" *ngIf="count > 10">
                <pagination-controls (pageChange)="changePageNumber($event)"></pagination-controls>
            </div>
        </article>
    </section>
</div>